module.exports = __webpack_public_path__ + "img/電気回路_1_1_2.2c81f15d.png";